// src/pages/Logistics.js
import React, { useEffect, useState, useCallback } from 'react';
import { getOrders, updateStatus } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { T, fmt, Card, Btn, StatCard, Empty, Spinner, SectionTitle, TH, TD } from '../components/UI';

export default function Logistics() {
  const { can } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await getOrders();
      setOrders(r.data.data.filter(o => ['PACKAGED','DISPATCHED','DELIVERED'].includes(o.status)));
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const action = async (id, status) => {
    try { await updateStatus(id, status); await load(); }
    catch(e) { alert(e.response?.data?.message || 'Failed'); }
  };

  const packaged  = orders.filter(o => o.status === 'PACKAGED');
  const transit   = orders.filter(o => o.status === 'DISPATCHED');
  const delivered = orders.filter(o => o.status === 'DELIVERED');

  if (loading) return <Spinner />;

  const tbl = (rows, actionCol) => (
    <table style={{ width:'100%', borderCollapse:'collapse' }}>
      <thead><tr><th style={TH}>Order</th><th style={TH}>Customer</th><th style={TH}>Amount</th><th style={TH}>Date</th>{actionCol&&<th style={TH}>Action</th>}</tr></thead>
      <tbody>{rows.map(o => (
        <tr key={o.id}>
          <td style={{ ...TD, color:T.gold, fontWeight:700 }}>{o.order_number}</td>
          <td style={TD}>{o.customer_name}</td>
          <td style={{ ...TD, fontWeight:600 }}>{fmt(o.total_amount)}</td>
          <td style={{ ...TD, color:T.muted, fontSize:'12px' }}>{new Date(o.created_at).toLocaleDateString('en-KE')}</td>
          {actionCol && <td style={TD}>{actionCol(o)}</td>}
        </tr>
      ))}</tbody>
    </table>
  );

  return (
    <div>
      <SectionTitle sub="Onyango coordinates · Langat dispatches">Logistics & Delivery</SectionTitle>
      <div style={{ display:'flex', gap:'14px', flexWrap:'wrap', marginBottom:'20px' }}>
        <StatCard label="Ready to Dispatch" value={packaged.length}  color={T.warning} />
        <StatCard label="In Transit"        value={transit.length}   color={T.info} />
        <StatCard label="Delivered"         value={delivered.length} color={T.success} />
      </div>

      {packaged.length > 0 && (
        <Card style={{ border:`1px solid ${T.warning}33` }}>
          <div style={{ fontSize:'13px', fontWeight:700, color:T.warning, marginBottom:'12px' }}>📦 Ready for Dispatch</div>
          {tbl(packaged, can('dispatch') ? o => <Btn size="sm" onClick={() => action(o.id,'DISPATCHED')}>🚚 Dispatch</Btn> : null)}
        </Card>
      )}
      {transit.length > 0 && (
        <Card style={{ border:`1px solid ${T.info}33` }}>
          <div style={{ fontSize:'13px', fontWeight:700, color:T.info, marginBottom:'12px' }}>🚚 In Transit</div>
          {tbl(transit, can('confirm_delivery') ? o => <Btn size="sm" variant="success" onClick={() => action(o.id,'DELIVERED')}>✅ Confirm Delivery</Btn> : null)}
        </Card>
      )}
      {delivered.length > 0 && (
        <Card>
          <div style={{ fontSize:'13px', fontWeight:700, color:T.success, marginBottom:'12px' }}>✅ Delivered</div>
          {tbl(delivered, o => <Btn size="sm" variant="ghost" onClick={() => action(o.id,'CLOSED')}>Close Order</Btn>)}
        </Card>
      )}
      {orders.length === 0 && <Card><Empty msg="No orders in logistics right now." /></Card>}
    </div>
  );
}
